import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { HeartIcon } from "../lib/icons";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { useNoIndex } from "../lib/useNoIndex";

/**
 * PaymentCancel — landing page when a donor abandons Stripe Checkout.
 *
 * Warm, non-shaming. Assume they clicked away for a good reason.
 */
export default function PaymentCancel() {
  useNoIndex();
  return (
    <main data-testid="payment-cancel-page" className="bg-sand">
      <Navbar
        onStart={() => (window.location.href = "/")}
        primaryLabel="Back to home"
        secondaryLabel={null}
      />

      <section className="mx-auto flex min-h-[75vh] max-w-2xl flex-col justify-center px-6 py-24 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="rounded-2xl border border-ink/10 bg-bone p-10 text-center shadow-[0_20px_60px_-20px_rgba(26,23,20,0.35)] lg:p-14"
        >
          <HeartIcon className="mx-auto h-10 w-10 text-tangerine" />
          <p className="mt-6 text-[13px] font-semibold uppercase tracking-[0.28em] text-olive">
            No worries
          </p>
          <h1 className="mt-2 font-serif text-3xl lg:text-[3.5rem] leading-tight text-ink">
            You didn&rsquo;t complete your gift.
          </h1>
          <p className="mx-auto mt-4 max-w-md text-base text-olive">
            Nothing was charged. The students are still there when you&rsquo;re ready —
            no pressure, no follow-up emails.
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/#campaigns"
              data-testid="payment-cancel-view-campaigns"
              className="inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3 text-base font-semibold text-sand transition-colors hover:bg-forest"
            >
              Browse campaigns <ArrowRight className="h-4 w-4" strokeWidth={2} />
            </Link>
            <Link
              to="/"
              className="inline-flex items-center gap-2 rounded-full border border-border bg-sand px-6 py-3 text-base font-semibold text-ink hover:border-ink"
            >
              Back to home
            </Link>
          </div>
        </motion.div>
      </section>

      <Footer variant="minimal" />
    </main>
  );
}
